import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Router, RouterModule } from '@angular/router';
import { PipesModule } from '@shared/pipes/pipes.module';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TsButtonModule, TSIconModule } from 'tsui';
import { MatMenuModule } from '@angular/material/menu';
import { ICellRendererParams } from 'ag-grid-enterprise';

export interface IAddressViewOnRendererParams extends ICellRendererParams {
  googleEarthConfig: any;
}
@Component({
  selector: 'app-address-renderer',
  standalone: true,
  imports: [MatIconModule, TsButtonModule, TSIconModule, MatMenuModule],
  template: `
    <ts-button type="icon" [matMenuTriggerFor]="menu" color="accent" icon="language"></ts-button>
    <mat-menu #menu="matMenu">
      <a
        href="https://earth.google.com/web/@{{ params.data.address?.latitude }},{{ params.data.address?.longitude }},{{
          params.googleEarthConfig.cameraAltitude
        }}d,{{ params.googleEarthConfig.zoom }}z"
        target="_blank"
      >
        <div class="item">
          <ts-icon outlined="true" icon="public"></ts-icon>
          <span>View on Google Earth</span>
        </div>
      </a>
      <a
        href="https://www.google.com/maps?q=loc:{{ params.data.address?.latitude }}+{{
          params.data.address?.longitude
        }}&ll={{ params.data.address?.latitude }},{{ params.data.address?.longitude }}&t=h"
        target="_blank"
      >
        <div class="item">
          <ts-icon outlined="true" icon="location_on"></ts-icon>
          <span>View on Google Maps</span>
        </div>
      </a>
      <a (click)="goToResearch(params)">
        <div class="item">
          <ts-icon outlined="true" icon="map"></ts-icon>
          <span>View on Parcel Map</span>
        </div>
      </a>
    </mat-menu>
  `,
  styles: [
    `
      .item {
        display: flex;
        align-items: center;
        padding: 0.5rem;
        gap: 0.5rem;
      }
      a {
        cursor: pointer;
      }
    `,
  ],
})
export class TableAddressViewOnRendererComponent implements ICellRendererAngularComp {
  public params: IAddressViewOnRendererParams;

  constructor(public router: Router) {}

  agInit(params: IAddressViewOnRendererParams): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }

  goToResearch(params): void {
    this.router.navigate(['/research'], {
      queryParams: { lat: params.data.address.latitude, lng: params.data.address.longitude },
    });
  }
}
